import {InjectionToken} from '@angular/core';

/**
 * Minimal shape of the HTTP response object available during SSR.
 * Provided by the Express server (see server.ts); absent in the browser.
 */
export interface ServerResponseRef {
  status(code: number): unknown;
}

export const SERVER_RESPONSE = new InjectionToken<ServerResponseRef>('SERVER_RESPONSE');
